module.exports = __webpack_public_path__ + "img/Span-07.8e2f3260.jpg";